var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (collection, displayNav, undefined) {
var fairBooths = collection
var width = 403
var height = 269
buf.push("<div class=\"fcc-carousel partner2-shows-carousel\">");
if ( displayNav)
{
buf.push("<a class=\"mgr-arrow-left icon-chevron-left js-mgr-prev\"></a><a class=\"mgr-arrow-right icon-chevron-right js-mgr-next\"></a>");
}
buf.push("<div class=\"mgr-cells js-mgr-cells\">");
// iterate fairBooths.models
;(function(){
  var $$obj = fairBooths.models;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var show = $$obj[$index];

buf.push("<div class=\"mgr-cell js-mgr-cell\"><a" + (jade.attr("href", show.href(), true, true)) + "><img" + (jade.attr("src", show.cropUrlFor({ width: width, height: height }), true, true)) + (jade.attr("alt", show.get('name'), true, true)) + " class=\"fcc-carousel-image\"></a><a" + (jade.attr("href", show.href(), true, true)) + " class=\"fcc-carousel-caption-title\"><em>" + (jade.escape(null == (jade_interp = show.get('name')) ? "" : jade_interp)) + "</em></a><div class=\"fcc-carousel-caption-dates\">" + (jade.escape(null == (jade_interp = show.runningDates()) ? "" : jade_interp)) + "</div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var show = $$obj[$index];

buf.push("<div class=\"mgr-cell js-mgr-cell\"><a" + (jade.attr("href", show.href(), true, true)) + "><img" + (jade.attr("src", show.cropUrlFor({ width: width, height: height }), true, true)) + (jade.attr("alt", show.get('name'), true, true)) + " class=\"fcc-carousel-image\"></a><a" + (jade.attr("href", show.href(), true, true)) + " class=\"fcc-carousel-caption-title\"><em>" + (jade.escape(null == (jade_interp = show.get('name')) ? "" : jade_interp)) + "</em></a><div class=\"fcc-carousel-caption-dates\">" + (jade.escape(null == (jade_interp = show.runningDates()) ? "" : jade_interp)) + "</div></div>");
    }

  }
}).call(this);

buf.push("</div></div>");}.call(this,"collection" in locals_for_with?locals_for_with.collection:typeof collection!=="undefined"?collection:undefined,"displayNav" in locals_for_with?locals_for_with.displayNav:typeof displayNav!=="undefined"?displayNav:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;